module.exports = __webpack_public_path__ + "static/img/40004 (4).6ed3699.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40004 (4).webp
// module id = XFOJ
// module chunks = 14